import React from 'react';
import { Typography } from '@mui/material';
import { isBefore } from 'date-fns';

const CommissionInfo = ({ tripMatch, tripPrice }: { tripMatch: any, tripPrice: { amount: number, currencyCode: string | undefined } }) => {
  const tripMatchCreatedAt = new Date(tripMatch.createdAt);
  const isBeforeOct1 = isBefore(tripMatchCreatedAt, new Date('2025-10-01'));
  const currencyFormatter = new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: tripPrice.currencyCode || 'USD',
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  });

  if (isBeforeOct1) {
    const commissionRecommendedAmount = tripPrice.amount * 0.08;
    return (
      <Typography variant="caption">
        This trip was matched before Oct 1, 2025; the commission rate is
        {' '}
        <Typography component="span" variant="captionBold">
          {commissionRecommendedAmount ? `8% of the total trip price: ${currencyFormatter.format(commissionRecommendedAmount)}.` : '8% of the total trip price.'}
        </Typography>
        {' '}
        The exception is separately priced airfare.
      </Typography>
    );
  }

  const commissionRecommendedAmount = tripPrice.amount * 0.105;
  return (
    <Typography variant="caption">
      This trip was matched on or after Oct 1, 2025; the commission rate is
      {' '}
      <Typography component="span" variant="captionBold">
        {commissionRecommendedAmount ? `10.5% of the total trip price: ${currencyFormatter.format(commissionRecommendedAmount)}.` : '10.5% of the total trip price.'}
      </Typography>
      {' '}
      The exception is separately priced airfare.
    </Typography>
  );
};

export default CommissionInfo;
